import {useEffect} from 'react';
import {useGetPendingCertificationsCount} from '../api/admin/useGetPendingCertificationsCount.ts';

interface PendingCertificationsUpdaterProps {
    isAuthenticated: boolean;
    isAdmin: boolean;
    onUpdate: (pendingCount: number) => void;
}

export function PendingCertificationsUpdater({
    isAuthenticated,
    isAdmin,
    onUpdate
}: PendingCertificationsUpdaterProps) {
    const {data: pendingCount} = useGetPendingCertificationsCount(
        isAuthenticated,
        isAdmin
    );

    useEffect(() => {
        onUpdate(pendingCount || 0);
    }, [pendingCount, onUpdate]);

    return null;
}
